import React from 'react';
import { LayoutDashboard, Heart, History, Settings, MessageSquare, ExternalLink } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useNavigate } from 'react-router-dom';
export function MyInquiriesPage() {
  const navigate = useNavigate();
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard'
  }, {
    label: 'Shortlisted Plots',
    icon: Heart,
    path: '/buyer/shortlisted'
  }, {
    label: 'My Inquiries',
    icon: History,
    path: '/buyer/inquiries'
  }, {
    label: 'Settings',
    icon: Settings,
    path: '/buyer/settings'
  }];
  const handleReply = (inquiryId: number) => {
    navigate(`/buyer/inquiries/${inquiryId}`);
  };
  const handleViewThread = (inquiryId: number) => {
    navigate(`/buyer/inquiries/${inquiryId}`);
  };
  return <DashboardLayout title="Buyer Dashboard" navItems={navItems} userInitials="JD" data-id="element-3046">
      <h1 className="text-2xl font-bold mb-8" data-id="element-3047">My Inquiries</h1>

      <div className="space-y-6" data-id="element-3048">
        {[{
        id: 1,
        plot: 'Premium Corner Plot in Hinjewadi',
        seller: 'Rajesh Kumar',
        lastMsg: 'Yes, the NA conversion was completed last month. I can share the document.',
        date: '2 hours ago',
        status: 'Replied',
        unread: true
      }, {
        id: 2,
        plot: 'Lake View Plot - Whitefield',
        seller: 'Bangalore Land Corp',
        lastMsg: 'Is the price negotiable for immediate payment?',
        date: 'Yesterday',
        status: 'Pending',
        unread: false
      }, {
        id: 3,
        plot: 'Gated Community Plot - Sector 45',
        seller: 'DLF Partners',
        lastMsg: 'Please schedule a site visit for this weekend.',
        date: 'Oct 18, 2024',
        status: 'Closed',
        unread: false
      }].map(inquiry => <div key={inquiry.id} className={`bg-white border ${inquiry.unread ? 'border-l-4 border-l-blue-500 border-y-gray-300 border-r-gray-300' : 'border-gray-300'} p-6 hover:shadow-sm transition-shadow`} data-id="element-3049">
            <div className="flex flex-col md:flex-row justify-between gap-4 mb-4" data-id="element-3050">
              <div data-id="element-3051">
                <h3 className="font-bold text-lg text-[#1f2933] flex items-center gap-2" data-id="element-3052">
                  {inquiry.plot}
                  <Link to={`/listing/${inquiry.id}`} className="text-gray-400 hover:text-gray-600" data-id="element-3053">
                    <ExternalLink className="w-4 h-4" data-id="element-3054" />
                  </Link>
                </h3>
                <p className="text-sm text-gray-500" data-id="element-3055">
                  Seller: {inquiry.seller}
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-3056">
                <span className={`px-2 py-1 text-xs font-bold rounded border ${inquiry.status === 'Replied' ? 'bg-green-100 text-green-800 border-green-200' : inquiry.status === 'Pending' ? 'bg-yellow-100 text-yellow-800 border-yellow-200' : 'bg-gray-100 text-gray-600 border-gray-200'}`} data-id="element-3057">
                  {inquiry.status.toUpperCase()}
                </span>
                <span className="text-xs font-mono text-gray-400" data-id="element-3058">
                  {inquiry.date}
                </span>
              </div>
            </div>

            <div className="bg-gray-50 p-4 border border-dashed border-gray-200 mb-4 rounded-sm" data-id="element-3059">
              <p className="text-sm text-gray-700 italic" data-id="element-3060">
                "{inquiry.lastMsg}"
              </p>
            </div>

            <div className="flex gap-3" data-id="element-3061">
              <button onClick={() => handleReply(inquiry.id)} className="flex items-center gap-2 px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-3062">
                <MessageSquare className="w-4 h-4" data-id="element-3063" /> Reply
              </button>
              <button onClick={() => handleViewThread(inquiry.id)} className="px-4 py-2 border border-gray-300 text-sm font-medium hover:bg-gray-50" data-id="element-3064">
                View Thread
              </button>
            </div>
          </div>)}
      </div>
    </DashboardLayout>;
}